// Modelo elegido en el selector del chat, recordado POR CONVERSACIÓN en el
// navegador (comodidad de este usuario, no estado compartido). null = "Modelo
// del agente". localStorage puede no existir o lanzar (ventana privada, datos
// bloqueados): sin él, el selector simplemente vuelve al modelo del agente.
const KEY_PREFIX = 'wb.chatModel.';

export const loadChatModel = (sessionId) => {
  if (!sessionId) return null;
  try {
    return window.localStorage.getItem(KEY_PREFIX + sessionId) || null;
  } catch {
    return null;
  }
};

export const saveChatModel = (sessionId, modelId) => {
  if (!sessionId) return;
  try {
    if (modelId) {
      window.localStorage.setItem(KEY_PREFIX + sessionId, modelId);
    } else {
      window.localStorage.removeItem(KEY_PREFIX + sessionId);
    }
  } catch {
    // Sin almacenamiento: la elección vale solo mientras la página siga abierta.
  }
};
